/**
 * 将 dom 元素全屏
 * @param {dom} element dom元素
 * @example
 * setFullscreen(document.documentElement) // 整个页面进入全屏
 * setFullscreen(document.getElementById("id")) // 某个元素进入全屏
 */
export function setFullScreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullScreen();
  }
}

/**
 * 检测数据是否为undefined
 * @param {*} data 检测数据
 */
export function isUndefined(data) {
  return typeof data === 'undefined';
}

/**
 * 退出全屏
 * @example
 * exitFullscreen();
 */
export function exitFullScreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}

/**
 * 从 window.location.href 中获取指定key的value
 * @param {*} key 要获取的 key
 * @returns window.location.href 中指定key对应的value
 * @example
 * const value = getUrlParam(key);
 */

export function getUrlParam(name) {
    var regexS = "[\\?&]" + name + "=([^/&#]*)";
    var regex = new RegExp(regexS);
    var tmpURL = document.location.href;
    var results = regex.exec(tmpURL);
    if (results == null) {
      return "";
    } else {
      return results[1];
    }
}

/*  金额格式化
 *  parameter：
 *  num：格式化目标数字
 *  decimal：保留几位小数，默认2位
 *  split：千分位分隔符，默认为,
 * moneyFormat(123456789.87654321, 2, ',') // 123,456,789.88
*/
export const moneyFormat = (num, decimal = 2, split = ',') => {
    function thousandFormat (num) {
        const len = num.length
        return len <= 3 ? num : thousandFormat(num.substr(0, len - 3)) + split + num.substr(len - 3, 3)
    }
    if (isFinite(num)) { // num是数字
        if (num === 0) { // 为0
        return num.toFixed(decimal)
        } else { // 非0
        var res = ''
        var dotIndex = String(num).indexOf('.')
        if (dotIndex === -1) { // 整数
            res = thousandFormat(String(num)) + '.' + '0'.repeat(decimal)
        } else { // 非整数
            // js四舍五入 Math.round()：正数时4舍5入，负数时5舍6入
            // Math.round(1.5) = 2
            // Math.round(-1.5) = -1
            // Math.round(-1.6) = -2
            // 保留decimals位小数
            const numStr = String((Math.round(num * Math.pow(10, decimal)) / Math.pow(10, decimal)).toFixed(decimal)) // 四舍五入，然后固定保留2位小数
            const decimals = numStr.slice(dotIndex, dotIndex + decimal + 1) // 截取小数位
            res = thousandFormat(numStr.slice(0, dotIndex)) + decimals
        }
        return res
        }
    } else {
        return '--'
    }
}




// WEBPACK FOOTER //
// ./src/utils/utils.js